import { Construction } from 'lucide-react'

import { Badge } from '@/components/ui/badge'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'

import { ADMIN_CAPABILITY_GAPS } from './constants'

/**
 * What administration is catalogued to do and this application still cannot — the same honesty
 * `LedgerCapabilityGaps` and `ReportsCapabilityGaps` keep for their own modules.
 *
 * An administrator who cannot find a control has to be able to tell three things apart: they lack
 * a permission, the register is genuinely empty, or the capability does not exist yet. Only naming
 * the third here prevents the other two readings, and nothing in this module shows a plausible
 * empty table in place of something the API never served.
 */
export function AdminCapabilityGaps() {
  return (
    <Card className="border-dashed">
      <CardHeader>
        <div className="min-w-0">
          <CardTitle className="flex items-center gap-2">
            <Construction className="size-4 text-muted" aria-hidden />
            Still not here
          </CardTitle>
          <p className="mt-0.5 text-xs text-muted">
            Each of these is a gap in the API or in this pass, not in your access.
          </p>
        </div>
      </CardHeader>

      <CardContent>
        <dl className="space-y-4">
          {ADMIN_CAPABILITY_GAPS.map((gap) => (
            <div key={gap.title} className="min-w-0">
              <dt className="flex flex-wrap items-center gap-2">
                <span className="text-sm font-semibold text-heading">{gap.title}</span>
                <Badge tone="neutral" className="font-mono">
                  {gap.permission}
                </Badge>
              </dt>
              <dd className="mt-0.5 text-xs text-body">{gap.detail}</dd>
            </div>
          ))}
        </dl>
      </CardContent>
    </Card>
  )
}
